module.exports = __webpack_public_path__ + "static/media/CC20-AP070-12.79b4cf36.png";